<template>
    <div>
        <figure><img src="../../../assets/lock-closed.png" /></figure>
        <span>Locked</span>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {};
</script>

<style lang="scss" scoped>
figure {
    display: inline-block;
    padding: 6px;
    border-radius: 100%;
    background-color: var(--color2);

    > img {
        height: 25px;
        width: 25px;
    }
}

span {
    display: inline-block;
    background-color: var(--color2);
    border-radius: 0 12px 12px 0;
    padding: 3px;
    padding-right: 6px;
    margin-left: -8px;
}
</style>



// WEBPACK FOOTER //
// lock.vue?ba3deec2